import { render } from "./StoreSetup.vue?vue&type=template&id=08ce7c6f"
import script from "./StoreSetup.vue?vue&type=script&lang=js"
export * from "./StoreSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__